

















































































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/modules/common'
import { getForbiddenUserList } from '@/api'
@Component({
  name: 'netoperation',
  components: {}
})
export default class NetOperation extends Vue {
  list: any = []

  created() {
    // 获取当前语言
    const data = (this.$route.query.language as string) || 'ug'
    this.getLanguage(data)
    CommonModule.setLanguage(data)

    //获取封禁用户列表
    this.getForbiddenUserList()
  }

  //获取封禁用户列表
  async getForbiddenUserList() {
    const { code, data } = await getForbiddenUserList()
    if (code == 1001) {
      this.list = data
      console.log(this.list, '//')
    }
  }

  // 当前语言
  get language() {
    return this.$i18n.locale
  }

  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }

  //返回
  handelback() {
    this.$router.back()
  }
}
